import { Grid } from "@mui/material"
import MDTypography from "components/MDTypography"
import { noteTypography } from "shared/styles/style"

export const tabs = [
  "Personal information",
  "Labour information",
  "Leave system",
  "PaySlips",
  "Apollo support",
  "Disciplinary records",
  "Your PIN code",
]

export const MenuTabs = (props) => {
  const { selectedTab, onClickTab, isDisabled } = props

  return (
    <Grid
      container
      alignItems="center"
      sx={({ functions: { pxToRem } }) => ({
        borderRadius: pxToRem(12),
        padding: pxToRem(4),
        background: "#F6F9FC",
        width: "fit-content",
      })}
      className="myself-tabs"
    >
      {tabs.map((item, index) => {
        return (
          <Grid
            item
            xs="auto"
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
            sx={({ breakpoints, functions: { pxToRem } }) => ({
              height: pxToRem(35),
              borderRadius: pxToRem(8),
              background: selectedTab === index ? "white" : "inherite",
              opacity: isDisabled ? 0.5 : 1,
              boxShadow:
                selectedTab === index ? "0px 2px 6px 0px #00000040" : "unset",
              cursor: "pointer",
              padding: `${pxToRem(0)} ${pxToRem(24)}`,

              [breakpoints.down(768)]: {
                width: "100%",
              },
            })}
            onClick={() => {
              if (!isDisabled) onClickTab(index)
            }}
          >
            <MDTypography
              sx={({ breakpoints }) => ({
                ...noteTypography(breakpoints),
                lineHeight: 1.25,
              })}
            >
              {item}
            </MDTypography>
          </Grid>
        )
      })}
    </Grid>
  )
}
